import React, { useState } from 'react';
import axios from 'axios';

function CurrencyConverter() {
  const [amount, setAmount] = useState('');
  const [fromCurrency, setFromCurrency] = useState('INR');
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const currencies = [
    { code: 'INR', name: 'Indian Rupee (INR)' },
    { code: 'PHP', name: 'Philippine Peso (PHP)' },
    { code: 'EUR', name: 'Euro (EUR)' },
    { code: 'GBP', name: 'British Pound (GBP)' },
    { code: 'JPY', name: 'Japanese Yen (JPY)' },
    { code: 'AUD', name: 'Australian Dollar (AUD)' },
    { code: 'CAD', name: 'Canadian Dollar (CAD)' },
    { code: 'CHF', name: 'Swiss Franc (CHF)' },
    { code: 'CNY', name: 'Chinese Yuan (CNY)' },
    { code: 'MXN', name: 'Mexican Peso (MXN)' },
    { code: 'NZD', name: 'New Zealand Dollar (NZD)' },
    { code: 'SGD', name: 'Singapore Dollar (SGD)' },
    { code: 'ZAR', name: 'South African Rand (ZAR)' },
    { code: 'BRL', name: 'Brazilian Real (BRL)' },
    { code: 'RUB', name: 'Russian Ruble (RUB)' }
  ];

  const handleConvert = async () => {
    if (!amount || isNaN(amount)) {
      setResult('Please enter a valid amount');
      return;
    }
    
    setLoading(true);
    try {
      // Note: In a production app, you would want to use a proper API key
      const response = await axios.get(
        `https://api.exchangerate-api.com/v4/latest/USD`
      );
      
      const rate = response.data.rates[fromCurrency];
      const usdAmount = amount / rate;
      setResult(`${amount} ${fromCurrency} = ${usdAmount.toFixed(2)} USD`);
    } catch (error) {
      setResult('Error fetching exchange rates. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="converter">
      <h2>Currency Converter</h2>
      <select value={fromCurrency} onChange={(e) => setFromCurrency(e.target.value)}>
        {currencies.map(currency => (
          <option key={currency.code} value={currency.code}>
            {currency.name}
          </option>
        ))}
      </select>
      <input
        type="number"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        placeholder={`Enter amount in ${fromCurrency}`}
      />
      <button onClick={handleConvert} disabled={loading}>
        {loading ? 'Converting...' : 'Convert to USD'}
      </button>
      {result && <div className="result">{result}</div>}
    </div>
  );
}

export default CurrencyConverter;
